export function getEnumTypedKeys(input) {
    // keys are always strings
    return getObjectTypedKeys(input).filter((key) => isNaN(Number(key)));
}
export function getEnumTypedValues(input) {
    const keys = getEnumTypedKeys(input);
    return keys.map((key) => input[key]);
}
export function isEnumValue(input, checkEnum) {
    return getEnumTypedValues(checkEnum).includes(input);
}
export function filterToEnumValues(inputs, checkEnum, caseInsensitive = false) {
    if (caseInsensitive) {
        return inputs.reduce((accum, currentInput) => {
            const matchedEnumValue = getEnumTypedValues(checkEnum).find((actualEnumValue) => {
                return String(actualEnumValue).toUpperCase() === String(currentInput).toUpperCase();
            });
            if (matchedEnumValue) {
                return accum.concat(matchedEnumValue);
            }
            else {
                return accum;
            }
        }, []);
    }
    else {
        return inputs.filter((input) => isEnumValue(input, checkEnum));
    }
}
export function getObjectTypedKeys(input) {
    return Object.keys(input);
}
export function getObjectTypedValues(input) {
    return Object.values(input);
}
export function typedHasOwnProperty(inputKey, inputObject) {
    return (typeof inputObject === 'object' &&
        inputObject &&
        Object.prototype.hasOwnProperty.call(inputObject, inputKey));
}
export function typedHasOwnProperties(inputKeys, inputObject) {
    return (typeof inputObject === 'object' &&
        inputObject &&
        inputKeys.every((key) => Object.prototype.hasOwnProperty.call(inputObject, key)));
}
export function isObject(input) {
    return typeof input === 'object' && !!input;
}
export function getEntriesSortedByKey(input) {
    return Object.entries(input).sort((tupleA, tupleB) => tupleA[0].localeCompare(tupleB[0]));
}
export function areJsonEqual(a, b) {
    try {
        const sortedAEntries = getEntriesSortedByKey(a);
        const sortedBEntries = getEntriesSortedByKey(b);
        return JSON.stringify(sortedAEntries) === JSON.stringify(sortedBEntries);
    }
    catch (error) {
        console.error(`Failed to compare objects using JSON.stringify`);
        throw error;
    }
}
/**
 * Creates a new object with the same properties as the input object, but with values set to the
 * result of mapCallback for each property.
 */
export function mapObject(inputObject, mapCallback) {
    let gotAPromise = false;
    const mappedObject = getObjectTypedKeys(inputObject).reduce((accum, currentKey) => {
        const mappedValue = mapCallback(currentKey, inputObject[currentKey]);
        if (mappedValue instanceof Promise) {
            gotAPromise = true;
        }
        return {
            ...accum,
            [currentKey]: mappedValue,
        };
    }, {});
    if (gotAPromise) {
        return new Promise(async (resolve, reject) => {
            try {
                await Promise.all(getObjectTypedKeys(mappedObject).map(async (key) => {
                    const value = await mappedObject[key];
                    mappedObject[key] = value;
                }));
                resolve(mappedObject);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    else {
        return mappedObject;
    }
}
/** The input here must be serializable otherwise JSON parsing errors will be thrown */
export function copyThroughJson(input) {
    try {
        return JSON.parse(JSON.stringify(input));
    }
    catch (error) {
        console.error(`Failed to JSON copy for`, input);
        throw error;
    }
}
